function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
import { BoxRenderer, OkCancelDialog } from "../../../..";
import StarRatings from "@limitless/modern/components/star-ratings/StarRatings";
import BinaryRatings from "@limitless/modern/components/binary-ratings/BinaryRatings";
import MultilineTextField from "@limitless/modern/inputs/multiline-text-field/MultilineTextField";
import TextField from "@limitless/modern/inputs/text-field/TextField";
import Typography from "@limitless/modern/data-display/typography/Typography";
import InfoIcon from "@limitless/icons/InfoCircle";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import { TextButton } from "@limitless/portal";
const SCHEME_TYPE_MAP = {
  "5-stars": {
    component: StarRatings,
    componentProps: {
      custScoreScheme: {
        name: "5-stars",
        maxScore: 5,
        defaultScore: 0
      }
    },
    additionalProps: {
      useDefaultScore: true,
      fontSize: 30,
      disabled: true,
      compact: true
    }
  },
  binary: {
    component: BinaryRatings,
    additionalProps: {
      disabled: true
    }
  },
  "text-input": {
    component: TextField,
    additionalProps: {
      id: "onboarding-review-criteria-text-input",
      placeholder: "Type here...",
      sx: {
        "&.MuiInputBase-root": {
          marginTop: "0px !important"
        }
      }
    }
  }
};
const useStyles = makeStyles({
  info: {
    borderRadius: "50%",
    width: 35,
    height: 35
  },
  attributeItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px!important"
  }
});
const OnboaringReviewCriteriaFeedback = ({
  reviewNotesEnabled,
  reviewNote = "",
  reviewCriteria = [],
  onCriteriaChange,
  onNoteChange
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const [info, setInfo] = React.useState(null);
  const showTitle = reviewCriteria.length > 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    paddingRight: 2,
    paddingBottom: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      marginBottom: 8,
      marginTop: 8
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "textPrimary"
  }, showTitle && t("Review Feedback"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    className: classes.criteria
  }, reviewCriteria.map((criteria, index) => {
    const {
      name,
      description,
      score,
      reviewScheme,
      reviewCriteriaId,
      optional,
      text
    } = criteria;
    const OBReviewCriteriaOptional = optional ? "(optional)" : null;
    const {
      component: Scheme,
      additionalProps = {}
    } = SCHEME_TYPE_MAP[reviewScheme];
    additionalProps.rating = score;
    const value = reviewScheme === "text-input" ? text || "" : score;
    if (onCriteriaChange) {
      additionalProps.disabled = false;
      additionalProps.onClick = ratingScore => onCriteriaChange(reviewCriteriaId, optional && ratingScore === 1 && ratingScore === score ? null : parseInt(ratingScore));
      additionalProps.onChange = e => onCriteriaChange(reviewCriteriaId, null, e.target.value);
    } else {
      additionalProps.disabled = true;
      additionalProps.onClick = null;
    }
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      key: index,
      style: {
        marginBottom: reviewScheme !== "text-input" ? 16 : 8
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      justifyContent: "space-between",
      flexDirection: "column",
      alignItems: "left",
      id: `reviewCriteria${index}`
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      justifyContent: "space-between",
      alignItems: "center",
      id: `reviewCriteria${index}`
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      style: {
        width: "90%"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary",
      variant: "body2"
    }, name, " ", OBReviewCriteriaOptional)), /*#__PURE__*/React.createElement(Grid, {
      item: true
    }, description && /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => setInfo({
        name,
        description
      }),
      icon: /*#__PURE__*/React.createElement(InfoIcon, null),
      label: t("info")
    }))), /*#__PURE__*/React.createElement(Grid, {
      style: {
        paddingTop: reviewScheme !== "text-input" ? 13 : 0
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      sx: reviewScheme === "text-input" && description ? {
        marginRight: 4
      } : {}
    }, !additionalProps.disabled && /*#__PURE__*/React.createElement(Grid, {
      display: "flex",
      justifyContent: "space-between"
    }, /*#__PURE__*/React.createElement(Scheme, _extends({
      value: value,
      onClick: () => null
    }, additionalProps)), reviewScheme === "binary" && optional && !additionalProps.disabled && /*#__PURE__*/React.createElement(TextButton, {
      onClick: () => {
        onCriteriaChange(reviewCriteriaId, null);
      }
    }, "clear Action"))), additionalProps.disabled && (reviewScheme === "binary" ? /*#__PURE__*/React.createElement(BoxRenderer, {
      showRadius: true,
      color: parseInt(score) === 0 ? "red" : "secondary-main",
      value: parseInt(score) === 0 ? t("No") : parseInt(score) === 1 ? t("Yes") : t("Not answered"),
      variant: "caption",
      containerStyles: {
        padding: "4px 12px"
      },
      noMargin: true,
      id: "scheme"
    }) : /*#__PURE__*/React.createElement(Grid, {
      item: true
    }, /*#__PURE__*/React.createElement(Scheme, _extends({
      value: reviewScheme === "text-input" ? text : score,
      onClick: () => null
    }, additionalProps)))))));
  }), reviewNotesEnabled && onNoteChange && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    mt: "4px"
  }, /*#__PURE__*/React.createElement(MultilineTextField, {
    onChange: event => onNoteChange(event.target.value),
    label: showTitle ? "Written feedback" : "Additional Feedback",
    name: "writtenfeedback",
    value: reviewNote || "",
    fullWidth: true,
    multiline: true,
    rows: 5
  })), reviewNotesEnabled && !onNoteChange && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    name: "feedback"
  }, "Feedback"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontStyle: "italic",
      marginTop: "8px",
      whiteSpace: "pre-line"
    }
  }, reviewNote)))), info && /*#__PURE__*/React.createElement(OkCancelDialog, {
    title: info.name,
    okLabel: "Close",
    dialogTitleProps: {
      marginLeft: 2,
      marginTop: 2
    },
    onOKClick: () => setInfo(null)
  }, /*#__PURE__*/React.createElement(Typography, null, info.description)));
};
OnboaringReviewCriteriaFeedback.propTypes = {
  reviewNotesEnabled: PropTypes.bool,
  reviewNote: PropTypes.string,
  reviewCriteria: PropTypes.array,
  onCriteriaChange: PropTypes.func,
  onNoteChange: PropTypes.func
};
export default OnboaringReviewCriteriaFeedback;